import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import style from "../components/watisweef.module.scss"
import Fig from "./Fig"

function createMarkup(tekst) {
  return { __html: tekst }
}

export default function WatIsWeef({ tekstCol, fotoCol, row }) {
  const data = useStaticQuery(
    graphql`
      query MyQuery {
        tekstJson {
          pagina {
            wat {
              body
              kop
            }
          }
        }
        withoos: file(relativePath: { eq: "withoos.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1000, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        atelier: file(relativePath: { eq: "atelier.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 2000, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  )

  const cols = ["1/8", "6/13", "11/18", "16/23"]

  return (
    <div className={style.wrapper} id="watisweef" style={{ gridRow: row }}>
      <div className={style.tekst} style={{ gridColumn: cols[tekstCol - 1] }}>
        <h2>{data.tekstJson.pagina.wat.kop}</h2>
        <p
          dangerouslySetInnerHTML={createMarkup(data.tekstJson.pagina.wat.body)}
        />
      </div>
      <div className={style.fotos} style={{ gridColumn: cols[fotoCol - 1] }}>
        <Fig
          image={data.withoos.childImageSharp.fluid}
          caption="Matthias Withoos, Gezicht op Amersfoort, 1671</br>Museum Flehite"
          stylo= {{height: '25vh'}}
        ></Fig>
        <Fig
          image={data.atelier.childImageSharp.fluid}
          caption="Twee mannen aan weefgetouw in psychiatrisch ziekenhuis Zon en Schild</br>20e eeuw Archief Eemland"
          stylo= {{height: '25vh'}}
          imgStylo={{ scale: "1.03" }}
        ></Fig>
      </div>
    </div>
  )
}
